import styled from 'styled-components';

import { Section as SectionDefault } from './index.base';

export const Section = styled(SectionDefault)`
  background-color: #efe1cc;
`;
